module.exports = __webpack_public_path__ + "img/medium-remnants.5831d0b1.png";